<template>
    <div>
        <label class="block text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider mb-1">{{ label }}</label>
        <p class="text-sm text-slate-800 dark:text-slate-200">{{ displayValue }}</p>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
	label: string
	value?: string | number | null
	capitalize?: boolean
}>()

const displayValue = computed(() => {
	if (!props.value && props.value !== 0) return '—'
	const val = String(props.value)
	return props.capitalize ? val.charAt(0).toUpperCase() + val.slice(1) : val
})
</script>
